import router from '@/router'
import * as types from '@/store/types.js'
import Type from '@/model/Type'
import {activeResource} from '@/store/helpers'
import app from '../../main'

const state = {
  types: [],
  activeType: {},
  isLoading: false
}

// GETTERS
const getters = {
  [types.ALL_TYPES]: state => state.types,
  [types.ACTIVE_TYPE]: state => state.activeType,
  [types.IS_LOADING_TYPES]: state => state.isLoading
}

// ACTIONS
const actions = {
  [types.GET_ALL_TYPES]: ({ commit }, value) => {
    commit(types.GET_ALL_TYPES, value)
  },
  [types.ADD_TYPE]: ({ commit }, value) => {
    commit(types.ADD_TYPE, value)
  },
  [types.REMOVE_TYPE]: ({ commit }, value) => {
    commit(types.REMOVE_TYPE, value)
  },
  [types.ACTIVE_TYPE]: ({ commit }) => {
    commit(types.ACTIVE_TYPE)
  },
  [types.IS_LOADING_TYPES]: ({ commit }, value) => {
    commit(types.IS_LOADING_TYPES, value)
  }
}

// MUTATIONS
const mutations = {
  [types.GET_ALL_TYPES] (state, value) {
    state.types = value.data
  },
  [types.ADD_TYPE]: (state, value) => {
    state.types.unshift(value)
  },
  [types.REMOVE_TYPE]: (state, value) => {
    Type.delete(value).then((response) => {
      state.types.forEach(type => {
        if (type.parent_id === value.id) {
          type.parent_id = null
        }
      })

      state.types = state.types.filter(obj => value.id !== obj.id)
      app.$snotify.success('Successfully deleted.')

      // If route is the same as deleted resource we need to redirect to /types
      if (router.currentRoute.params.id === value.id) {
        router.push({ name: 'types.index' })
      }
    })
  },
  [types.ACTIVE_TYPE]: (state, value) => {
    state.activeType = activeResource(state.types, 'typeId')
  },
  [types.IS_LOADING_TYPES]: (state, value) => {
    state.isLoading = value
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/Type.js